// import React, { useState, useEffect } from "react";
// import { Box, Typography, Paper, Divider } from "@mui/material";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import DescriptionIcon from "@mui/icons-material/Description";
// import Navbar from "../components/Navbar";
// import { api } from "../helpers/apiRequest";
// import { toast } from "react-toastify";
// import colors from "../theme/Colors";
// import OrderReport from "../components/reports/OrderReport";
// import BalanceReport from "../components/reports/BalanceReport";
// import SalesReport from "../components/reports/SalesReport";
// import GstSaleReport from "../components/reports/GstSaleReport";
// import CashOrderReport from "../components/reports/CashOrderReport";
// import InvoiceOrderReport from "../components/reports/InvoiceOrderReport";
// import PackingListReport from "../components/reports/PackingListReport";
// import RateHistoryReport from "../components/reports/RateHistoryReport";
// import OrderProgressReport from "../components/reports/OrderProgressReport";
// import ItemRateReport from "../components/reports/ItemRateReport";
// import TaxSummaryReport from "../components/reports/TaxSummaryReport";
// import GSTPurchaseReport2 from "../components/reports/GSTPurchaseReport2";
// import PurchaseOrderBalanceReport from "../components/reports/PurchaseOrderBalanceReport";

// function Reports() {
//   const [customers, setCustomers] = useState([]);
//   const [items, setItems] = useState([]);
//   const [styles, setStyles] = useState([]);
//   useEffect(() => {
//     const fetchFilterData = async () => {
//       try {
//         const [customersRes, itemsRes, stylesRes] = await Promise.all([
//           api.get("users/users/role/customer"),
//           api.get("inventory/items"),
//           api.get("inventory/styles"),
//         ]);
//         setCustomers(customersRes.data.data || []);
//         setItems(itemsRes.data.message || []);
//         setStyles(stylesRes.data.message || []);
//       } catch (error) {
//         console.error("Error fetching filter data:", error);
//         toast.error("Failed to load filter data");
//       }
//     };

//     fetchFilterData();
//   }, []);

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", padding: 2, gap: 4 }}>
//       <Navbar title="Reports" />
//       {

//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Order Summary Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <OrderReport customers={customers} />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Customer Balance Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <BalanceReport customers={customers} />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Item Style Sales Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <SalesReport customers={customers} items={items} styles={styles} />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 GST Sale Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <GstSaleReport customers={customers} />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Cash Order Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <CashOrderReport />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Invoice Order Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <InvoiceOrderReport />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Packing List Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <PackingListReport />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Rate History Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <RateHistoryReport customers={customers} items={items} styles={styles} />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Order Progress Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <OrderProgressReport />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Item Rate Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <ItemRateReport customers={customers} items={items} styles={styles} />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Tax Summary Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <TaxSummaryReport />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 GST Purchase Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <GSTPurchaseReport2 />
//           </Paper>

//           <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }}>
//             <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//               <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
//               <Typography variant="h5" component="h2" sx={{ color: 'black' }}>
//                 Purchase Order Balance Report
//               </Typography>
//             </Box>

//             <Divider sx={{ mb: 3 }} />

//             <PurchaseOrderBalanceReport />
//           </Paper>
//         </LocalizationProvider>

//       }

//     </Box>
//   );
// }

// export default Reports;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Divider,
  useMediaQuery, // Import useMediaQuery for responsive adjustments
  useTheme, // Import useTheme for breakpoints
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import DescriptionIcon from "@mui/icons-material/Description";
import Navbar from "../components/Navbar";
import { api } from "../helpers/apiRequest";
import { toast } from "react-toastify";
import colors from "../theme/Colors"; // Assuming colors.primary is defined here
import OrderReport from "../components/reports/OrderReport";
import BalanceReport from "../components/reports/BalanceReport";
import SalesReport from "../components/reports/SalesReport";
import GstSaleReport from "../components/reports/GstSaleReport";
import CashOrderReport from "../components/reports/CashOrderReport";
import InvoiceOrderReport from "../components/reports/InvoiceOrderReport";
import PackingListReport from "../components/reports/PackingListReport";
import RateHistoryReport from "../components/reports/RateHistoryReport";
import OrderProgressReport from "../components/reports/OrderProgressReport";
import ItemRateReport from "../components/reports/ItemRateReport";
import TaxSummaryReport from "../components/reports/TaxSummaryReport";
import GSTPurchaseReport2 from "../components/reports/GSTPurchaseReport2";
import PurchaseOrderBalanceReport from "../components/reports/PurchaseOrderBalanceReport";
import OrderPaymentReport from "../components/reports/OrderPaymentReport";

function Reports() {
  const [customers, setCustomers] = useState([]);
  const [items, setItems] = useState([]);
  const [pstyles, setPStyles] = useState([]);
  const [parties, setParties] = useState([]);
  const [styles, setStyles] = useState([]);
  // Get theme breakpoints for responsive styling
  const theme = useTheme();
  // Check if screen is small (e.g., mobile)
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Less than 600px

  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        const [customersRes,partiesRes, itemsRes, pstylesRes,stylesRes] = await Promise.all([
          api.get("users/users/role/customer"),
          api.get("inventory/party"),
          api.get("inventory/items"),
          api.get("inventory/pstyles"),
          api.get("inventory/styles"),
        ]);
        setCustomers(customersRes.data.data || []);
        setParties(partiesRes.data.message || []);
        setItems(itemsRes.data.message || []);
        setPStyles(pstylesRes.data.message || []);
        setStyles(stylesRes.data.message || []);
      } catch (error) {
        console.error("Error fetching filter data:", error);
        toast.error("Failed to load filter data");
      }
    };

    fetchFilterData();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        // Responsive padding: smaller on extra-small screens, default on larger
        padding: { xs: 1, sm: 2, md: 3 },
        gap: { xs: 2, sm: 3, md: 4 }, // Responsive gap between report sections
        width: '95%', // Ensure it takes full available width
        // Add a max-width for content readability on very wide screens
        maxWidth: '1200px',
        margin: '0 auto', // Center the content when max-width is applied
      }}
    >
      <Navbar title="Reports" />

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/* Each Paper component acts as a container for a report */}
        {[
          { title: "Order Summary Report", component: OrderReport, props: { customers } },
          { title: "Customer Balance Report", component: BalanceReport, props: { customers } },
          { title: "Item Style Sales Report", component: SalesReport, props: { customers, items, styles } },
          { title: "Invoice Sale Report", component: GstSaleReport, props: { customers } },
          { title: "Cash Sheet", component: CashOrderReport, props: {} },
          { title: "Invoice Sheet", component: InvoiceOrderReport, props: {} },
          { title: "Packing List Report", component: PackingListReport, props: {} },
          { title: "Rate History Report", component: RateHistoryReport, props: { customers,parties,pstyles, items } },
          { title: "Order Progress Report", component: OrderProgressReport, props: {} },
          { title: "Order Payment Report", component: OrderPaymentReport, props: {} },
          { title: "Item Rate Report", component: ItemRateReport, props: { customers, items, styles } },
          { title: "Tax Summary Report", component: TaxSummaryReport, props: {} },
          { title: "GST Purchase Report", component: GSTPurchaseReport2, props: {} },
          { title: "Purchase Order Balance Report", component: PurchaseOrderBalanceReport, props: {} },
        ].map((report, index) => (
          <Paper
            key={index} // Using index as key is okay if the list is static and not reordered
            elevation={3}
            sx={{
              // Responsive padding for each Paper section
              p: { xs: 2, sm: 3, md: 4 },
              mb: { xs: 2, sm: 3, md: 4 }, // Responsive margin-bottom between sections
              borderRadius: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <DescriptionIcon sx={{ mr: 1, color: colors.primary }} />
              <Typography
                // Responsive Typography variant for report titles
                variant={isSmallScreen ? "h6" : "h5"}
                component="h2"
                sx={{ color: 'black' }}
              >
                {index+1}. {report.title}
              </Typography>
            </Box>

            <Divider sx={{ mb: 3 }} />

            {/* Render the specific report component */}
            <report.component {...report.props} />
          </Paper>
        ))}
      </LocalizationProvider>
    </Box>
  );
}

export default Reports;
